import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CookiesProvider } from 'react-cookie';
import { useSelector } from 'react-redux';

import './App.scss';
import { ROUTES } from './constants/routes';
import PrivateRoute from './components/PrivateRoute';
import CommercialSubscription from './views/CommercialSubscription';
import CommercialSubscriptionLogin from './views/CommercialSubscription/CommercialSubscriptionLogin';
import CommercialSubscriptionSignup from './views/CommercialSubscription/CommercialSubscriptionSignup';
import CommercialSubscriptionDashboard from './views/CommercialSubscription/CommercialSubscriptionDashboard';
import SuccessfulCheckout from './views/SuccessfulCheckout';
import TermsOfService from './views/TermsOfService';
import PrivacyInfo from './views/PrivacyInfo';
import Dashboard from './views/Dashboard';
import Login from './views/Login';
import UploadContent from './views/UploadContent';
import LiveContent from './views/LiveContent';
import Playlist from './views/Playlist';
import Home from './views/Home';
import Kontakt from './views/Kontakt';
import Musicmind from './views/Musicmind';
import LydBranding from './views/LydBranding';
import HandleTags from './views/HandleTags';
import TaggedPlaylist from './views/TaggedPlaylist';
import TaggedContent from './views/TaggedContent';
import TaggedPlaylistDetailView from './views/TaggedPlaylist/TaggedPlaylistDetailView';
import Units from './views/Units';
import Music from './views/Music';
import Presentations from './views/Presentations';
import DynamicPlaylist from './views/DynamicPlaylist';
import Musik from './views/Musik';
import Signage from './views/Signage';
import AboutUs from './views/AboutUs';

function App() {
  const { user } = useSelector(state => state.userAuthentication);
  const loggedIn = useSelector(state => state.userAuthentication.loggedIn);

  return (
    <CookiesProvider>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
      />
      <Router>
        <Switch>
          <Route exact path={ROUTES.HOME} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <Home />
          )} />
          <Route exact path={ROUTES.MUSIK} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <Musik />
          )} />
          <Route exact path={ROUTES.SIGNAGE} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <Signage />
          )} />
          <Route exact path={ROUTES.ABOUTUS} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <AboutUs />
          )} />
          <Route exact path={ROUTES.KONTAKT} render={() => (
            <Kontakt />
          )} />
          <Route exact path={ROUTES.MUSICMIND} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <Musicmind />
          )} />
          <Route exact path={ROUTES.COMMERCIALSUBSCRIPTION} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <CommercialSubscription />
          )} />
          <Route exact path={ROUTES.SUCCESSFULCHECKOUT} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <SuccessfulCheckout />
          )} />
          <Route exact path={ROUTES.TERMSOFSERVICE} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <TermsOfService />
          )} />
          <Route exact path={ROUTES.PRIVACYINFO} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <PrivacyInfo />
          )} />
          <Route exact path={ROUTES.COMMERCIALSUBSCRIPTIONLOGIN} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <CommercialSubscriptionLogin />
          )} />
          <Route exact path={ROUTES.COMMERCIALSUBSCRIPTIONSIGNUP} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <CommercialSubscriptionSignup />
          )} />
          {/* <Route exact path={ROUTES.COMMERCIALSUBSCRIPTIONDASHBOARD} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <CommercialSubscriptionDashboard />
          )} /> */}
          <Route exact path={ROUTES.LYDBRANDING} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <LydBranding />
          )} />
          <Route exact path={ROUTES.LOGIN} render={() => (
            loggedIn ? <Redirect to={ROUTES.DASHBOARD} /> : <Login />
          )} />
          <PrivateRoute path={ROUTES.DASHBOARD} auth={loggedIn ? user : null} component={Dashboard} />
          <PrivateRoute path={ROUTES.COMMERCIALSUBSCRIPTIONDASHBOARD} auth={loggedIn ? user : null} component={CommercialSubscriptionDashboard} />
          <PrivateRoute path={ROUTES.UPLOADCONTENT} auth={loggedIn ? user : null} component={UploadContent} />
          <PrivateRoute path={ROUTES.LIVECONTENT} auth={loggedIn ? user : null} component={LiveContent} />
          <PrivateRoute path={ROUTES.PLAYLIST} auth={loggedIn ? user : null} component={Playlist} />
          <PrivateRoute path={ROUTES.HANDLETAGS} auth={loggedIn ? user : null} component={HandleTags} />
          <PrivateRoute path={ROUTES.TAGGEDPLAYLIST} auth={loggedIn ? user : null} component={TaggedPlaylist} />
          <PrivateRoute path={ROUTES.TAGGEDPLAYLISTDETAIL} auth={loggedIn ? user : null} component={TaggedPlaylistDetailView} />
          <PrivateRoute path={ROUTES.TAGGEDCONTENT} auth={loggedIn ? user : null} component={TaggedContent} />
          <PrivateRoute path={ROUTES.UNITS} auth={loggedIn ? user : null} component={Units} />
          <PrivateRoute path={ROUTES.MUSIC} auth={loggedIn ? user : null} component={Music} />
          <PrivateRoute path={ROUTES.PRESENTATION} auth={loggedIn ? user : null} component={Presentations} />
          <PrivateRoute path={ROUTES.DYNAMICPLAYLIST} auth={loggedIn ? user : null} component={DynamicPlaylist} />
        </Switch>
      </Router>
    </CookiesProvider>
  );
}

export default App;
